import dibsCss from 'dibs-css';
import classnames from 'classnames';
import { type FunctionComponent } from 'react';

type LockProps = {
    className?: string;
};

const Lock: FunctionComponent<LockProps> = props => {
    return (
        <svg
            className={classnames(dibsCss.dibsIcon, props.className)}
            data-tn={'lock'}
            viewBox="0 0 518 518"
        >
            <path d="M423.3 241v-71.2c-.1-1.9-2.5-47.3-15.4-71.1-7.9-14.6-20.8-36.1-41.3-54.7-21.9-19.7-49-33-80.6-39.3-5.3-1.1-17.8-2.2-30.6-2.2-10.4 0-19.2.7-26.3 2.1-30.7 6.2-87 26.1-119 90.5-16.6 33.5-16 81.1-16 81.6.3 14.7.1 21.4 0 31.6-.1 7.6-.3 16.9-.3 32.7H43.5v274.3l427.5.2V241h-47.7zm-315.1-64.5c-.2-12.3 2-49.9 14.5-75.1 29.3-59 81-77.3 109.2-83 6.1-1.2 14.2-1.9 23.5-1.9 12.5 0 24 1.1 27.8 1.9 64.8 13 94.1 53.4 112.3 87 11 20.4 13.6 62 13.8 65v71.2h-60.9L348 171v-.6c-4.8-48.2-27.3-71.3-45.4-82.1-19.2-11.5-37.3-12-39.1-12-48.9-1.3-72.4 25.5-83.5 47.9-11.5 23.1-12.1 46-12.1 47v70.5h-60.1c0-16 .2-25.3.3-33 .3-10 .4-17.2.1-32.2zm73.7 64.5v-69.7c0-1.2.9-21.6 10.8-41.4 13.2-26.4 35.9-39.7 67.4-39.7h3.2c.2 0 15.5.1 32 10 22.3 13.3 35.3 37.3 38.7 71.2l.4 69.6H181.9zM57.5 501.3V255.6H457l-.3 245.6-399.2.1z" />
        </svg>
    );
};
export default Lock;
